<template>
  <div id="app">
    <keep-alive include="AiChatView">
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  watch: {
    $route(val) {},
  },
  methods: {},
};
</script>
<style lang="scss">
html,
body {
  margin: 0px;
}

body {
  min-width: 1440px;
  overflow-x: auto;

  &.ss {
    min-width: initial;
    overflow-x: hidden;
  }

  p {
    margin: 0px;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
}

#app {
  color: #000000;
  font-size: 16px;
  font-weight: 400;
}
</style>
<style lang="scss">
/* // 公共样式 */
.dialog_c {
  border-radius: 16px !important;
  width: auto;
}

.dialog_c .el-dialog__title {
  font-size: 16px;
  color: #000000;
  line-height: 40px;
}

.dialog_c .el-dialog__header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 0 20px;
  height: 40px;
  padding-top: 10px;
}
.dialog_c .el-button {
  border-radius: 20px;
}

</style>

